"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationServiceImpl = void 0;
var NotificationProviderImpl_1 = require("./provider/firebase/NotificationProviderImpl");
var NotificationProviderImpl_2 = require("./provider/airabbi/NotificationProviderImpl");
var NotificationServiceImpl = (function () {
    function NotificationServiceImpl(cfg) {
        this.cfg = cfg;
        switch (cfg.provider) {
            case 'firebase':
                this.provider = new NotificationProviderImpl_1.NotificationProviderImpl(cfg);
                break;
            case 'airabbi':
                this.provider = new NotificationProviderImpl_2.NotificationProviderImpl(cfg);
                break;
        }
    }
    NotificationServiceImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        return this.provider.init(env);
    };
    NotificationServiceImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
        this.provider.setDebuggable(debuggable);
    };
    NotificationServiceImpl.prototype.createNotification = function (category, receiver, title, subTitle, content) {
        return this.provider.createNotification(category, receiver, title, subTitle, content);
    };
    NotificationServiceImpl.prototype.removeNotification = function (receiver, id) {
        return this.provider.removeNotification(receiver, id);
    };
    NotificationServiceImpl.prototype.getNotification = function (id) {
        return this.provider.getNotification(id);
    };
    NotificationServiceImpl.prototype.getNotifications = function () {
        return this.provider.getNotifications();
    };
    NotificationServiceImpl.prototype.markAsRead = function (id) {
        return this.provider.markAsRead(id);
    };
    NotificationServiceImpl.prototype.markAsUnread = function (id) {
        return this.provider.markAsUnread(id);
    };
    NotificationServiceImpl.prototype.listenUnreadNotifications = function (callback) {
        return this.provider.listenUnreadNotifications(callback);
    };
    NotificationServiceImpl.prototype.listenUnreadNotificationsGlobally = function (callback) {
        return this.provider.listenUnreadNotificationsGlobally(callback);
    };
    NotificationServiceImpl.prototype.markAllAsUnread = function () {
        return this.provider.markAllAsUnread();
    };
    NotificationServiceImpl.prototype.stopAllMonitor = function () {
        return this.provider.stopAllMonitor();
    };
    NotificationServiceImpl.prototype.sendEventNotify = function (unit, event, message) {
        return this.provider.sendEventNotify(unit, event, message);
    };
    NotificationServiceImpl.prototype.subscribeEventNotify = function (unit, event, listener) {
        return this.provider.subscribeEventNotify(unit, event, listener);
    };
    return NotificationServiceImpl;
}());
exports.NotificationServiceImpl = NotificationServiceImpl;
//# sourceMappingURL=NotificationServiceImpl.js.map